<template>
  <div
    v-if="staticCampaign || slides.length > 0"
    :class="container"
  >
    <div
      v-if="staticCampaign"
      class="d-none d-lg-block col-lg-6"
    >
      <campaign-content
        :variant="variant"
        :headline-size="headlineSize"
        :campaign="staticCampaign"
      ></campaign-content>
    </div>
    <div
      v-if="slides.length > 0"
      :class="[
        'col-12',
        {
          'col-lg-6': !!staticSlotName
        }
      ]"
    >
      <div class="card">
        <div
          :id="`${id}-indicators`"
          class="carousel slide"
        >
          <ol
            v-if="slides.length > 1"
            class="carousel-indicators"
          >
            <li
              v-for="(slide, i) in slides"
              :data-target="`#${id}-indicators`"
              :data-slide-to="i"
              :class="{
                'active': i === 0
              }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(slide, i) in slides"
              :class="[
                'carousel-item',
                {
                  'active': i === 0
                }
              ]"
            >
              <campaign-content
                :variant="variant"
                :headline-size="headlineSize"
                :campaign="slide.campaign"
              ></campaign-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignContent from './CampaignContent'
import { getCampaigns } from '@/api'
import { map } from 'lodash'
import $ from 'jquery'

export default {
  components: {
    CampaignContent
  },
  props: {
    id: {
      type: String,
      required: true
    },
    container: {
      type: String,
      default: null
    },
    staticSlotName: {
      type: [String, Array],
      required: false,
      default: null
    },
    carouselSlotName: {
      type: [String, Array],
      required: false,
      default: null
    },
    headlineSize: {
      type: String,
      default: 'h3'
    },
    variant: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      staticCampaign: null,
      carouselCampaigns: []
    }
  },
  computed: {
    slides () {
      let slides = []

      if (this.carouselCampaigns.length) {
        slides = map(this.carouselCampaigns, (campaign) => {
          return {
            campaign
          }
        })
      }

      if ($(window).width() <= 992) {
        if (this.staticCampaign) {
          slides.unshift({
            campaign: this.staticCampaign
          })
        }
      }

      return slides
    }
  },
  watch: {
    slides () {
      this.$nextTick(() => {
        let $carousel = $(this.$el).find('.carousel')
        $carousel.carousel(0)
      })
    }
  },
  mounted () {
    if (this.staticSlotName) {
      this.loadStaticCampaign()
    }
    if (this.carouselSlotName) {
      this.loadCarouselCampaigns()
    }
  },
  methods: {
    async loadStaticCampaign () {
      let campaigns = await this.loadCampaigns(this.staticSlotName)
      if (campaigns.length) {
        this.staticCampaign = campaigns[0]
      }
    },
    async loadCarouselCampaigns () {
      this.carouselCampaigns = await this.loadCampaigns(this.carouselSlotName)
    },
    async loadCampaigns (slots) {
      let response = await getCampaigns(slots)
      return response.data.data
    }
  }
}
</script>
